
    (async () => {
      try {
        const { openFile } = await import('https://root.cern/js/latest/modules/io.mjs');
        window.__JSROOT = { openFile };
      } catch (e) {
        window.__JSROOT = null;
        console.warn('JSROOT load failed:', e);
      }
    })();
  